@if (type === 'overlay') {
  <div
    [style.visibility]= "isVisible ? 'visible' : 'hidden'"
    class="toolbox-overlay">
    <div class='background'></div>
    <mat-card
       [ngClass]='["toolbox", type, "gallery",
                   displayTitle ? "w-title" : "wo-title"]'>
      <mat-card-header>
        @if (displayTitle) {
          <mat-card-title>
            {{ 'i18n.toolbox.gallery.title' | translate }}
          </mat-card-title>
        }
        <mat-icon svgIcon="close"
          class="close-x"
        (click)="btnCancelClick()"></mat-icon>
      </mat-card-header>
      <mat-card-content [ngClass]='["gallery-container"]'>
        <gallery (imageClicked)="changeImage($event)"></gallery>
      </mat-card-content>
      @if (type === 'overlay') {
        <mat-card-actions [ngClass]='["buttons"]'
          >
          <button mat-raised-button (click)="btnOKClick()"
            size="small"
            translate>
            i18n.button.close
          </button>
          @if (showUploadButton) {
            <div class="button image-select">
              <input imageUpload #imageSelect id="image-select" type="file"
                multiple accept="image/*"/>
              <button mat-raised-button color="primary"
                size="small"
                (click)="imageSelect.click(); trackUploadPhotos();" translate>
                i18n.button.uploadPhotos
              </button>
            </div>
          }
        </mat-card-actions>
      }
    </mat-card>
  </div>
}

@if (type === 'static') {
  <div class="toolbox-static">
    <div class="header">
      @if (displayTitle) {
        @if (displayTitle) {
          <span class="title">
            <mat-icon svgIcon="photos"></mat-icon>
            {{ 'i18n.toolbox.gallery.title' | translate }}
          </span>
        }
        <hr class="title-hr" />
      }
    </div>
    <div class="body" [ngClass]='["gallery-container"]'>
      <gallery (imageClicked)="changeImage($event)"></gallery>
    </div>
  </div>
}
